var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('webix-ui',{attrs:{"config":_vm.ui},model:{value:(_vm.company_users),callback:function ($$v) {_vm.company_users=$$v},expression:"company_users"}}),_c('div',{attrs:{"id":"usersPaging"}}),_c('div',[(_vm.showModal_editUsersModal)?_c('UsersEditModal'):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }